module.exports = __webpack_public_path__ + "img/holderImg.b490c613.jpg";